module.exports = __webpack_public_path__ + "img/14.02adc027.png";